export default "__VITE_ASSET__99dece9e__"